import type { UploadedFileType } from '../../../contexts';

export function getUniqueFile(
  file: UploadedFileType,
  name: string
): UploadedFileType {
  if (file.name === name) {
    return file;
  }

  return Object.assign(
    new File([file], name, {
      type: file.type,
      lastModified: file.lastModified
    }),
    { uploaded: file.uploaded, originName: file.name }
  );
}
